export { default as Label } from './Label';
export { default as TabPanel } from './TabPanel';
export { default as StyledTab } from './StyledTab';
export { default as StyledTabs } from './StyledTabs';
